import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AbstractCourseMenuComponent, mapStateToProps } from './abstract'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import { Table } from '~/components/table'
import * as route from '~/helper/constant/route'
import * as SVG from '~/assets/svg'
import { Loading } from '~/components/loader'
import { withTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'

class CourseMenuComponent extends AbstractCourseMenuComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
        this.getClass = this.getClass.bind(this)
    }

    getClass() {
        if(this.state.loading === true){
            const data = this.state.classes.map((_, index) => {
                return (
                    <div key={index} className="folder-list question-bank-list clearfix qbl">
                        <a href="#" style={{display:'block'}} className="folder-img">
                            <Skeleton style={{dispaly:"block"}}/>
                        </a>
                        <a href="#" className="folder-name">
                        <Skeleton />
                        </a>
                    </div>
                )
            })
            return data
            
        }
        else{
            const data = this.state.classes.map((item, index) => {
                return (
                    <div key={index} className="folder-list question-bank-list clearfix qbl" onClick={() => (window.location = route.course.view + '/' + item.id)}>
                        <a href={route.course.view + '/' + item.id} className="folder-img">
                            {SVG.questionClass()}
                        </a>
                        <a href={route.course.view + '/' + item.id} className="folder-name">
                            <div className="move-sent">{item.name}</div>
                        </a>
                    </div>
                )
            })
            return data

        }
        
    }

    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Sidebar id="course" />
                <Loading status={this.state.loading} text="Loading" />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.course.menu}>{t('course:course')}</a>
                            </li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-5 float-left">
                                <span className="sub-main-title">{t('common:viewBtn')}</span>
                                <h5 className="main-title heading5">{t('course:course')}:</h5>
                            </div>
                        </div>
                    </div>
                    <div className="folder-page">
                        <div className="clearfix">
                            <div className="float-left">
                                {this.getClass()}
                                {/* <div className="folder-list question-bank-list clearfix" onClick={() => (window.location = route.course.view + '/' + 0)}>
                                    <a href={route.course.view + '/' + 0} className="folder-img">
                                        {SVG.questionClass()}
                                    </a>
                                    <a href={route.course.view + '/' + 0} className="folder-name">
                                    {t('course:others')}  
                                    </a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const CourseMenu = withTranslation()(connect(mapStateToProps)(CourseMenuComponent))

export { CourseMenu }
